import { useContext } from 'react';
import { GridsContext } from 'context/GridsContext';

const useGridsState = () => {
  return useContext(GridsContext);
}

export { useGridsState };